import React from 'react';

interface SuccessIconProps {
  width?: number;
  height?: number;
}

const SuccessIcon: React.FC<SuccessIconProps> = ({ 
  width = 49, 
  height = 48 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 49 49" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M24.5068 46.0048C36.6283 46.0048 46.4547 36.3789 46.4547 24.5048C46.4547 12.6306 36.6283 3.00476 24.5068 3.00476C12.3853 3.00476 2.5589 12.6306 2.5589 24.5048C2.5589 36.3789 12.3853 46.0048 24.5068 46.0048Z" fill="#2BC275"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M33.1575 17.5258C33.7996 18.0649 33.8739 19.0119 33.3236 19.6409L23.6108 30.7412C23.3384 31.0525 22.9479 31.241 22.53 31.2629C22.1121 31.2848 21.7032 31.1382 21.3985 30.8572L16.4747 26.3161C15.8589 25.7483 15.8297 24.799 16.4094 24.1958C16.9891 23.5926 17.9582 23.564 18.5739 24.1319L22.3297 27.5956L30.9983 17.6885C31.5487 17.0595 32.5154 16.9867 33.1575 17.5258Z" fill="black"/>
    </svg>
  );
};

export default SuccessIcon;

